import { NotifyHelper } from "../../../helpers/toast";
import {
  eDmMucThuNienCheActionIds,
  eDmMucThuNienCheActionsObj,
} from "../../action-types/category/IDmMucThuNienCheActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const mucThuNienCheActions = {
  ...generateActions(eDmMucThuNienCheActionsObj, "MUC_THU_NIEN_CHE"),
  ...generateActionForKey(
    eDmMucThuNienCheActionIds,
    "MUC_THU_NIEN_CHE",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã cập nhật");
    },
  ),
  ...generateActionForKey(
    eDmMucThuNienCheActionIds,
    "MUC_THU_NIEN_CHE",
    "SAVE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    },
  ),
  ...generateActionForKey(
    eDmMucThuNienCheActionIds,
    "MUC_THU_NIEN_CHE",
    "LOCK_SUCCESS",
    () => {
      NotifyHelper.Success("Khoá thành công");
    },
  ),
  ...generateActionForKey(
    eDmMucThuNienCheActionIds,
    "MUC_THU_NIEN_CHE",
    "LOCK_ERRR",
    (m: string) => {
      NotifyHelper.Error(m);
    },
  ),
  ...generateActionForKey(
    eDmMucThuNienCheActionIds,
    "MUC_THU_NIEN_CHE",
    "UNLOCK_SUCCESS",
    () => {
      NotifyHelper.Success("Mở khóa thành công");
    },
  ),
  ...generateActionForKey(
    eDmMucThuNienCheActionIds,
    "MUC_THU_NIEN_CHE",
    "UNLOCK_ERRR",
    (m: string) => {
      NotifyHelper.Error(m);
    },
  ),
  ...generateActionForKey(
    eDmMucThuNienCheActionIds,
    "MUC_THU_NIEN_CHE",
    "COPY_SUCCESS",
    () => {
      NotifyHelper.Success("Sao chép thành công");
    },
  ),
  ...generateActionForKey(
    eDmMucThuNienCheActionIds,
    "MUC_THU_NIEN_CHE",
    "COPY_ERROR",
    () => {
      NotifyHelper.Error("Sao chép không thành công");
    },
  ),
  ...generateActionForKey(
    eDmMucThuNienCheActionIds,
    "MUC_THU_NIEN_CHE",
    "PREVIEW_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    },
  ),
  ...generateActionForKey(
    eDmMucThuNienCheActionIds,
    "MUC_THU_NIEN_CHE",
    "AP_DUNG_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    },
  ),
};
